import {Component, ElementRef, HostListener, OnInit, ViewChild} from '@angular/core';
import {IonInput, LoadingController} from '@ionic/angular';
import {BehaviorSubject, Observable} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../../../services/auth-service/auth.service';
import {InspectionService} from '../../../inspect/services/inspection-service/inspection.service';
import {ConfigService} from '../../../services/config-service/config.service';
import {PoleList} from '../../../services/pole-list-service/pole-list';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {PoleItem} from '../../../services/pole-list-service/pole-item';
import {PoleImage} from '../../../services/api-service/api.service';

@UntilDestroy()
@Component({
    selector: 'app-cropping-page',
    templateUrl: './cropping-page.component.html',
    styleUrls: ['./cropping-page.component.scss']
})
export class CroppingPageComponent implements OnInit {

    @ViewChild('filterTextInput', {static: true})

    private filterTextInputComponent: IonInput;

    @ViewChild('filterTextInput') set filterTextInput(content: IonInput) {
        this.filterTextInputComponent = content;
    }

    @ViewChild('filterWrapper', {static: true})
    private filterWrapperRef: ElementRef;

    private get filterWrapper(): HTMLElement {
        return this.filterWrapperRef.nativeElement;
    }

    @ViewChild('sortWrapper', {static: true})
    private sortWrapperRef: ElementRef;

    private get sortWrapper(): HTMLElement {
        return this.sortWrapperRef.nativeElement;
    }

    viewModeSource: BehaviorSubject<string>;
    viewMode$: Observable<string>;

    viewContentSource: BehaviorSubject<string>;
    viewContent$: Observable<string>;

    modeText = 'Cropping';
    pageTitle = '';

    displayModeSource: BehaviorSubject<string>;
    displayMode$: Observable<string>;

    filterTypeSource: BehaviorSubject<string>;
    filterType$: Observable<string>;

    filterSubTypeSource: BehaviorSubject<string>;
    filterSubType$: Observable<string>;

    sortTypeSource: BehaviorSubject<string>;
    sortType$: Observable<string>;

    hasLidarSource: BehaviorSubject<boolean>;
    hasLidar$: Observable<boolean>;

    selectedPoleImageIsReadOnly = false;

    hideFilterText = true;
    filterText = '';

    loadingIndicator;

    showMap = false;
    showLidar = false;
    showDeepZoom = true;

    constructor(private route: ActivatedRoute,
                private router: Router,
                public authService: AuthService,
                public inspectionService: InspectionService,
                public loadingController: LoadingController,
                public configService: ConfigService) {

        this.displayModeSource = new BehaviorSubject<string>('filter');
        this.displayMode$ = this.displayModeSource.asObservable();

        this.filterTypeSource = new BehaviorSubject<string>(PoleList.FILTER_NONE);
        this.filterType$ = this.filterTypeSource.asObservable();

        this.filterSubTypeSource = new BehaviorSubject<string>(PoleList.CANT_INSPECT_ALL);
        this.filterSubType$ = this.filterSubTypeSource.asObservable();

        this.sortTypeSource = new BehaviorSubject<string>(PoleList.SORT_BY_TIMESTAMP);
        this.sortType$ = this.sortTypeSource.asObservable();

        this.viewModeSource = new BehaviorSubject<string>('CROPPING');
        this.viewMode$ = this.viewModeSource.asObservable();

        this.viewContentSource = new BehaviorSubject<string>('INSPECTION_BATCH');
        this.viewContent$ = this.viewContentSource.asObservable();

        this.hasLidarSource = new BehaviorSubject<boolean>(false);
        this.hasLidar$ = this.hasLidarSource.asObservable();

        console.log('this.router.url.indexOf(\'cropping\'): ', this.router.url.indexOf('cropping'));

        // if (this.authService.isAdmin) {
        //     if (this.router.url.indexOf('view') !== -1) {
        //         this.viewMode = 'FULL_VIEW';
        //         this.modeText = 'View';
        //     } else {
        //         this.viewMode = 'INSPECT';
        //         this.modeText = 'Inspect';
        //     }
        // } else if (this.authService.isInspector) {
        //     if (this.router.url.indexOf('view') !== -1) {
        //         this.viewMode = 'FULL_VIEW';
        //         this.modeText = 'View';
        //     } else {
        //         this.viewMode = 'INSPECT';
        //         this.modeText = 'Inspect';
        //     }
        // } else if (this.authService.isClient) {
        //     this.viewMode = 'CLIENT_VIEW';
        //     this.modeText = 'View';
        // } else {
        //     this.viewMode = 'FULL_VIEW';
        //     this.modeText = 'View';
        // }

        this.pageTitle = this.modeText;

        this.route.queryParamMap.subscribe(params => {
            const inspectionBatchId = params.get('inspection_batch_id');
            const depotId = params.get('depot_id');
            const poleId = params.get('pole_id');
            const poleName = params.get('pole_name');

            if (inspectionBatchId) {
                this.viewContent = 'INSPECTION_BATCH';
                this.loadInspectionBatch(inspectionBatchId);
            } else if (depotId) {
                this.viewContent = 'DEPOT';
                this.loadDepotById(depotId);
            } else if (poleId) {
                this.viewContent = 'POLE';
                this.loadPoleById(poleId);
            } else if (poleName) {
                this.viewContent = 'POLE';
                this.loadPoleByName(poleName);
            }
        });


        this.inspectionService.currentInspectionBatch$.pipe(
            untilDestroyed(this)
        ).subscribe((inspectionBatch) => {
            if (inspectionBatch && inspectionBatch.inspectionBatchName) {
                this.pageTitle = `${this.modeText} - ${inspectionBatch.inspectionBatchName}`;
            } else {
                this.pageTitle = `${this.modeText}`;
            }
        });

        // this.inspectionService.currentPoleList.currentPoleItem$.pipe(
        //     untilDestroyed(this)
        // ).subscribe((poleItem) => {
        //
        // });

        this.filterType$.pipe(
            untilDestroyed(this)
        ).subscribe(filterType => {
            // Clear the filter text when switching filter types
            this.filterText = '';
            this.filterSubType = PoleList.CANT_INSPECT_ALL;

            // Show or hide the filter text box
            switch (filterType) {
                case PoleList.FILTER_NONE:
                case PoleList.FILTER_NO_NOTE:
                case PoleList.FILTER_DEFECTS:
                case PoleList.FILTER_CANT_INSPECT:
                case PoleList.FILTER_NO_DEFECT:
                    this.hideFilterText = true;
                    break;
                case PoleList.FILTER_BY_POLE_NAME:
                case PoleList.FILTER_BY_POLE_ID:
                case PoleList.FILTER_BY_IMAGE_NAME:
                case PoleList.FILTER_BY_IMAGE_ID:
                    this.hideFilterText = false;

                    if (this.filterTextInputComponent) {
                        this.filterTextInputComponent.setFocus();
                    }
                    break;
            }

            if (this.inspectionService.currentPoleList) {
                this.inspectionService.currentPoleList.filter(filterType, this.filterText, this.filterSubType);
            }
        });

        this.filterSubType$.pipe(
            untilDestroyed(this)
        ).subscribe(filterSubType => {
            if (this.inspectionService.currentPoleList) {
                this.inspectionService.currentPoleList.filter(this.filterType, this.filterText, filterSubType);
            }
        });

        this.sortType$.pipe(
            untilDestroyed(this)
        ).subscribe(sortType => {
            if (this.inspectionService.currentPoleList) {
                this.inspectionService.currentPoleList.sortCurrentPoleListItems(sortType);
            }
        });

        // Check if this environment has lidar data. Used to show/hide the lidar button
        if (this.configService.getLidarPath()) {
            this.hasLidar = true;
        }
    }

    ngOnInit() {

    }

    ionViewDidEnter() {
        this.inspectionService.disableKeyboardShortcuts = false;
    }

    ionViewWillLeave() {
        this.inspectionService.disableKeyboardShortcuts = true;
    }

    ionViewDidLeave() {
        this.inspectionService.clearCurrentInspectionBatch();
    }

    get displayMode(): string {
        return this.displayModeSource.getValue();
    }

    set displayMode(value: string) {
        this.displayModeSource.next(value);
    }

    get filterType(): string {
        return this.filterTypeSource.getValue();
    }

    set filterType(value: string) {
        this.filterTypeSource.next(value);
    }

    get filterSubType(): string {
        return this.filterSubTypeSource.getValue();
    }

    set filterSubType(value: string) {
        this.filterSubTypeSource.next(value);
    }

    get sortType(): string {
        return this.sortTypeSource.getValue();
    }

    set sortType(value: string) {
        this.sortTypeSource.next(value);
    }

    get viewMode(): string {
        return this.viewModeSource.getValue();
    }

    set viewMode(value: string) {
        this.viewModeSource.next(value);
    }

    get viewContent(): string {
        return this.viewContentSource.getValue();
    }

    set viewContent(value: string) {
        this.viewContentSource.next(value);
    }


    get hasLidar(): boolean {
        return this.hasLidarSource.getValue();
    }

    set hasLidar(value: boolean) {
        this.hasLidarSource.next(value);
    }

    async presentLoading(message: string = 'Loading. Please wait.') {
        this.loadingIndicator = await this.loadingController.create({
            spinner: 'bubbles',
            message: message,
            backdropDismiss: false
        });
        await this.loadingIndicator.present();

        const {role, data} = await this.loadingIndicator.onDidDismiss();
    }

    dismissLoading() {
        setTimeout(() => {
            if (this.loadingIndicator) {
                this.loadingIndicator.dismiss();
            }
        }, 2000);

    }

    onInputFocus() {
        this.inspectionService.disableKeyboardShortcuts = true;
    }

    onInputBlur() {
        this.inspectionService.disableKeyboardShortcuts = false;
    }

    updateFilterText(event) {
        if (event !== null && event.detail !== null && event.detail.value !== null) {
            this.setFilterText(event.detail.value);
        }
    }

    async loadInspectionBatch(id: string) {
        this.presentLoading();

        try {
            await this.inspectionService.getInspectionBatch(id);
        } catch (error) {
            console.error(error);
        } finally {
            this.dismissLoading();
        }
    }

    async loadDepotById(id: string) {
        // this.presentLoading();

        await this.inspectionService.loadPoleListByDepotId(id);

        // if (this.authService.isClient) {
        //     this.filterType = PoleList.FILTER_NO_DEFECT;
        // }

        // this.dismissLoading();
    }

    async loadPoleByName(name: string) {
        // this.presentLoading();

        await this.inspectionService.loadPoleByName(name);

        // this.dismissLoading();
    }

    async loadPoleById(id: string) {
        // this.presentLoading();

        await this.inspectionService.loadPoleById(id);

        // this.dismissLoading();
    }

    setFilterText(filterText: string) {
        this.filterText = filterText;
        this.inspectionService.currentPoleList.filter(this.filterType, this.filterText);
    }

    nextPoleWithEvent(ev) {
        if (ev.shiftKey) {
            this.inspectionService.currentPoleList.nextNonInspectedPole();
        } else {
            this.inspectionService.currentPoleList.nextPole();
        }
    }

    prevPoleWithEvent(ev) {
        if (ev.shiftKey) {
            this.inspectionService.currentPoleList.prevNonInspectedPole();
        } else {
            this.inspectionService.currentPoleList.prevPole();
        }
    }

    selectedCropArea(rect) {
        if (this.viewMode === 'CROPPING') {
            this.inspectionService.updateCropArea(rect);

        }
    }

    selectedArea(rect) {
        if (this.viewMode === 'INSPECT') {
            if (this.inspectionService.currentPoleList &&
                this.inspectionService.currentPoleList.currentPoleItem) {
                const poleItem = this.inspectionService.currentPoleList.currentPoleItem;

                if (poleItem.poleStatus === PoleItem.NO_NOTE || poleItem.poleStatus === PoleItem.DEFECT) {
                    this.inspectionService.addDefectNote();
                }
            }
        }
    }

    poleImageSelectedIsReadOnly(value: boolean) {
        // console.log('selectedPoleImageIsReadOnly:', value);

        if (this.viewContent === 'POLE') {
            this.selectedPoleImageIsReadOnly = false;
        } else {
            this.selectedPoleImageIsReadOnly = value;
        }
    }

    poleImageSelected(poleImage: PoleImage) {
        // console.log('poleImageSelected: ', poleImage);

        this.inspectionService.currentPoleList.currentPoleItem.currentPoleImage = poleImage;
    }

    @HostListener('window:keydown', ['$event'])
    onKeyDown(event) {
        if (this.inspectionService.disableKeyboardShortcuts) {
            return;
        }

        // console.log('event.code: ', event.code);

        switch (event.code) {
            case 'ArrowRight':
                if (event.shiftKey) {
                    this.inspectionService.nextNonInspectedImage();
                } else {
                    this.inspectionService.nextPole();
                }
                break;
            case 'ArrowLeft':
                if (event.shiftKey) {
                    this.inspectionService.prevNonInspectedImage();
                } else {
                    this.inspectionService.prevPole();
                }
                break;
            case 'ArrowUp':
                this.inspectionService.prevPoleImage();
                break;
            case 'ArrowDown':
                this.inspectionService.nextPoleImage();
                break;
            case 'Digit0':
            case 'Backquote':
                if (this.viewMode === 'CROPPING') {
                    if (this.inspectionService.currentPoleList &&
                        this.inspectionService.currentPoleList.currentPoleItem) {
                        if (event.shiftKey) {
                            console.log('Set Side: Unset');
                            this.inspectionService.markSide(0);
                        } else {
                            console.log('Set Shot Framing: Unset');
                            this.inspectionService.markShotFraming(0);
                        }
                    }
                }
                break;
            case 'Digit1':
                if (this.viewMode === 'CROPPING') {
                    if (this.inspectionService.currentPoleList &&
                        this.inspectionService.currentPoleList.currentPoleItem) {

                        if (event.shiftKey) {
                            console.log('Set Side: Front');
                            this.inspectionService.markSide(1);
                        } else {
                            console.log('Set Shot Framing: Overview');
                            this.inspectionService.markShotFraming(1);
                        }
                    }
                }
                break;
            case 'Digit2':
                if (this.viewMode === 'CROPPING') {
                    if (this.inspectionService.currentPoleList &&
                        this.inspectionService.currentPoleList.currentPoleItem) {
                        if (event.shiftKey) {
                            console.log('Set Side: Back');
                            this.inspectionService.markSide(2);
                        } else {
                            console.log('Set Shot Framing: Top Third');
                            this.inspectionService.markShotFraming(2);
                        }
                    }
                }
                break;
            case 'KeyR':
                if (this.viewMode === 'CROPPING') {
                    if (this.inspectionService.currentPoleList &&
                        this.inspectionService.currentPoleList.currentPoleItem) {
                        this.inspectionService.markReflight();
                    }
                }
                break;
            case 'KeyD':
                if (this.viewMode === 'CROPPING') {
                    if (this.inspectionService.currentPoleList &&
                        this.inspectionService.currentPoleList.currentPoleItem) {
                        this.inspectionService.markNoReflight();
                    }
                }
                break;
        }

        event.stopPropagation();
    }

    segmentChanged(ev: any) {
        if (ev && ev.detail && ev.detail.value) {
            this.displayMode = ev.detail.value;
        }
    }

}
